<script>
import ItemList from '@components/item-list.vue'
import Subslide from '@components/slide-subslide.vue'

export default {
  components: { ItemList, Subslide },
  props: {
    report : {
      type: Object,
      required: true
    },
    subslide: {
      type: Number,
      required: false,
      default: null
    }
  },
  computed: {
    searchItems() {
      const seed = Math.round(Math.sin(this.report.id) * this.report.data.searches.length);
      const items = this.report.data.searches.map((search) => (
        {
          label:search.q,
          url:search.url
        }
      )).map((s, i) => {
        return { ...s, index: i};
      }).sort((a,b) => (seed % (a.index + 1)) - (seed % (b.index + 1)));
        // .slice(0, this.searchLimit);

      items.push({
        label: this.$t('searches.many_more'),
        url: '//google.com',
        primary: false
      });
      
      return items;
    },
    searchLimit() {
      return Math.floor(Math.min(1400, window.innerWidth) / 250) * 3;
    }
  }
}
</script>
<template>
 <div>
    <h3>{{ $t('searches.heading') }}</h3>
    <ItemList :items="searchItems" :limit="searchLimit + 1" :expandable="true" />
    <Subslide :index="0" :current-index="subslide">
      <p>
        <em>{{ $t('searches.info_text') }}</em>
      </p>
      <p>
        <BaseButton :is-primary="true" icon="question-mark" @click="$emit('help')">
          <span>{{$t('searches.help.title')}}</span>
        </BaseButton>
      </p>
    </Subslide>
  </div>
</template>